import { Component, Input } from '@angular/core';

export interface HowItWorksStep {
  icon: string;
  titleKey: string;
  descriptionKey: string;
  hasYellowBackground: boolean;
}

@Component({
  selector: 'app-how-it-works',
  standalone: false,
  templateUrl: './how-it-works.component.html',
  styleUrl: './how-it-works.component.scss'
})
export class HowItWorksComponent {
  @Input() stepIconUrls: (string | null)[] = [null, null, null];

  eyebrowIcon: string = 'helping-hand';
  eyebrowIconColor: string = '#96080B';
  eyebrowTextKey: string = 'home.how_it_works.eyebrow';
  headlineKey: string = 'home.how_it_works.heading';

  steps: HowItWorksStep[] = [
    {
      icon: 'heart-handshake',
      titleKey: 'home.how_it_works.step1.title',
      descriptionKey: 'home.how_it_works.step1.description',
      hasYellowBackground: true
    },
    {
      icon: 'contribute-confidently',
      titleKey: 'home.how_it_works.step2.title',
      descriptionKey: 'home.how_it_works.step2.description',
      hasYellowBackground: true
    },
    {
      icon: 'shield-check',
      titleKey: 'home.how_it_works.step3.title',
      descriptionKey: 'home.how_it_works.step3.description',
      hasYellowBackground: true
    }
  ];
}
